<template>
	<v-container fill-height fluid class="pa-0">
		<Aviso />
		<Excluir />
		<Novo />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovoAviso()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170"
						locale="pt-BR" dense fixed-header class="table-item" :items="avisos" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.data_inicio="{ item }">
								{{mostrarData(item.data_inicio)}}
							</template>
							<template v-slot:item.data_fim="{ item }">
								{{mostrarData(item.data_fim)}}
							</template>
							<template v-slot:item.action="{ item }">
								<v-btn icon color="primary" :disabled="item.ordenacao == minOrdenacao" @click="subir(item)">
									<v-icon>mdi-arrow-up</v-icon>
								</v-btn>
								<v-btn icon class="mx-1" color="primary"  :disabled="item.ordenacao == maxOrdenacao" @click="descer(item)">
									<v-icon>mdi-arrow-down</v-icon>
								</v-btn>
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon class="mx-1" color="primary"  @click="alterarStatus(item)">
									<v-icon v-if="item.status_aviso == 'ativo'">mdi-close-thick</v-icon>
									<v-icon v-else>mdi-check</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, showError, showSuccess } from "@/config/global"
	import axios from 'axios'
	import Aviso from '@/components/cadastros/avisos/Aviso'
	import Excluir from '@/components/cadastros/avisos/ExcluirAviso'
	import Novo from '@/components/cadastros/avisos/NovoAviso'
	import metodos from '@/mixins/metodos.js'
	import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
		components:{Aviso, Excluir, Novo},
		data(){
			return {
				loading: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				showModal: false,
				registro: {},
				avisos: [],
				fields: [
					{value: 'ordenacao', text: 'Ordem', align: 'center', sortable: 'false'},
					{value: 'id', text: 'Código', align: 'center', sortable: 'false'},
					{value: 'titulo', text: 'Titulo', align: 'center', sortable: 'false'},
					{value: 'data_inicio', text: 'Inicio', align: 'start', sortable: 'false'},
					{value: 'data_fim', text: 'Fim', align: 'center', sortable: 'false'},
					{value: 'status_aviso', text: 'Status', align: 'center', sortable: 'false'},
					{text: 'Ações', value: 'action', align: 'center', divider: true, sortable: 'false'}
				],

			}
		},
		computed:{
			maxOrdenacao(){
				let ordem = []
				this.avisos.forEach(v => {
					ordem.push(parseInt(v.ordenacao))
				})
				return Math.max(... ordem)
			},

			minOrdenacao(){
				let ordem = []
				this.avisos.forEach(v => {
					ordem.push(parseInt(v.ordenacao))
				})
				return Math.min(... ordem)
			}
		},
		methods:{
			buscaAvisos(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/avisos/read.php`

				axios.get(url)
						.then(res => {
							if(res.data.codigo == "01"){
								this.avisos = res.data.dados.map(av => {
									return {
										...av,
										inicioObj: this.converterData(av.data_inicio),
										fimObj: this.converterData(av.data_fim)
									}
								})
							}
							this.totalPaginas = Math.ceil(this.avisos.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			chamaModal(registro){
				this.registro = registro
				this.showModal = true
			},
			close(){
				this.showModal = false
			},
			editar(aviso){
				Br.setEditarAviso(aviso)
			},
			criarNovoAviso(){
				Br.setNovoAviso()
			},
			subir(aviso){
				const url = `${baseApiUrl}/Cadastros/avisos/ordenarUp.php`

				axios.post(url, {id: aviso.id, ordenacao: aviso.ordenacao})
					.then(res => {

						if(res.data.codigo == '01'){
							this.avisos = res.data.dados.map(avs => {
								return{
									...avs
								}
							})
						}
					})
			},

			alterarStatus(item){
				const url = `${baseApiUrl}/Cadastros/avisos/alterarStatus.php`

				axios.post(url, {id: item.id, status: item.status_aviso})
					.then(res => {

						if(res.data.codigo == '01'){
							showSuccess(res.data.mensagem)

							let idx = this.avisos.findIndex((v) => {
								return v.id == item.id
							})

							this.avisos[idx].status_aviso = res.data.status
						}else{
							showError(res.data.mensagem)
						}

					})
			},

			descer(aviso){
				const url = `${baseApiUrl}/Cadastros/avisos/ordenarDown.php`

				axios.post(url, {id: aviso.id, ordenacao: aviso.ordenacao})
					.then(res => {
						if(res.data.codigo == '01'){
							this.avisos = res.data.dados.map(avs => {
								return{
									...avs
								}
							})
						}
					})
			},

			excluir(aviso){

				Br.setExcluirAviso(aviso)
				
			}

		},

		created(){
			this.buscaAvisos()

			Br.onAvisoExcluido(aviso => {
					let idx = this.avisos.findIndex((v) => {
                               return v.id == aviso.id
                            })

                            this.avisos.splice(idx, 1)
				})

			Br.onAvisoCadastrado(aviso => {
				this.avisos.push(aviso)
			})

			Br.onAvisoAtualizado(aviso => {
				let idx = this.avisos.findIndex((v) => {
                               return v.id == aviso.id
							})
							
							this.avisos[idx] = aviso
			})
		}
	}
</script>

<style scoped>

</style>